import { PageTargetingRule, PageTargetingCondition } from '../dto/GuideDTO';

interface PageTargetingRuleConfig {
  url: string;
  rule: PageTargetingRule;
}

interface PageTargeting {
  rules: PageTargetingRuleConfig[];
  condition: PageTargetingCondition;
}

export const normalizeUrl = (url: string): string => {
  return url.endsWith('/') ? url.slice(0, -1) : url;
};

const checkRule = (rule: PageTargetingRuleConfig, currentUrl: string): boolean => {
  switch (rule.rule) {
    case PageTargetingRule.EQUALS: {
      const normalizedCurrentUrl = normalizeUrl(currentUrl);
      const normalizedRuleUrl = normalizeUrl(rule.url);
      return normalizedCurrentUrl === normalizedRuleUrl;
    }
    case PageTargetingRule.NOT_EQUALS: {
      const normalizedCurrentUrlNotEquals = normalizeUrl(currentUrl);
      const normalizedRuleUrlNotEquals = normalizeUrl(rule.url);
      return normalizedCurrentUrlNotEquals !== normalizedRuleUrlNotEquals;
    }
    case PageTargetingRule.CONTAINS:
      return currentUrl.includes(rule.url);
    case PageTargetingRule.NOT_CONTAINS:
      return !currentUrl.includes(rule.url);
    case PageTargetingRule.STARTS_WITH:
      return currentUrl.startsWith(rule.url);
    case PageTargetingRule.ENDS_WITH:
      return currentUrl.endsWith(rule.url);
    case PageTargetingRule.REGEX:
      try {
        const regex = new RegExp(rule.url);
        return regex.test(currentUrl);
      } catch {
        return false;
      }
    default:
      return false;
  }
};

export const checkPageTargeting = (pageTargeting: PageTargeting, currentUrl: string): boolean => {
  if (!pageTargeting?.rules?.length) return false;

  const results = pageTargeting.rules.map(rule => checkRule(rule, currentUrl));

  if (pageTargeting.condition === PageTargetingCondition.AND) {
    return results.every(result => result);
  }

  return results.some(result => result);
};
